import { Injectable } from '@angular/core'
import { AuthConfig, AuthConfigInitializer } from '@spartacus/core'
import { combineLatest, map, Observable } from 'rxjs'

@Injectable({
  providedIn: 'root'
})
export class CustomAuthConfigInitializer extends AuthConfigInitializer {
  private readonly baseSitePath: Record<string, string> = {
    'asaleocare-au': 'au',
    'asaleocare-nz': 'nz'
  }

  protected resolveConfig(): Observable<AuthConfig> {
    return combineLatest({
      baseSite: this.baseSiteService.getActive(),
      authConfig: this.configInit.getStable('authentication.initializerOptions')
    }).pipe(
      map(({ baseSite, authConfig }) => {
        return {
          authentication: {
            client_id: this.generateClientId(baseSite, authConfig),
            OAuthLibConfig: {
              redirectUri: this.generateRedirectUri(baseSite, authConfig)
            }
          }
        }
      })
    )
  }

  /**
   * Set redirectUri using /au or /nz base, instead of ootb base site (asaleocare-au or asaleocare-nz)
   */
  protected generateRedirectUri(activeBaseSite: string, config: AuthConfig) {
    const addBaseSiteToRedirectUri = config.authentication?.initializerOptions?.addBaseSiteToRedirectUri

    if (addBaseSiteToRedirectUri === true || (addBaseSiteToRedirectUri === 'auto' && this.baseSiteInUrl())) {
      const urlRoot =
        config.authentication?.OAuthLibConfig?.redirectUri ??
        (!this.isSSR ? this.windowRef.nativeWindow?.location.origin : '')

      return `${urlRoot}/${this.baseSitePath[activeBaseSite]}`
    } else {
      return config.authentication?.OAuthLibConfig?.redirectUri
    }
  }
}
